<!-- 项目文件 -->
<template>
    <div class="bgfff pl16 pr16 bgf0fc pt24">
        <div class="w70p mauto  disflex bgfff  bradius50 border1f8">
            <div class="w60p disinblock box c1f8 bgfff pl15 pr15 pt10 pb10  textc fs15 fbold bradius50"
                :class="{bgact:isAct == 1}" @click="changeBg(1)">驾校管理后台</div>
            <div class="w40p disinblock box c1f8 bgfff pl15 pr15 pt10 pb10  textc fs15 fbold bradius50"
                :class="{bgact:isAct == 2}" @click="changeBg(2)"> 集团版 </div>
        </div>

      
            <div class="mt24" v-if="isAct==1">
                <ul class="w100p disinblock">
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">班型管理:班型个性化设置，满足招生服务差异化需求。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">学员管理:信息快速采集，关联教练，学习进度查询管理。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">人员管理:教练工作任务管理，考勤绩效管理。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">约课管理:多样约课模式任意组合，一 键排班。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">车辆管理:行驶里程，维修记录，保险提醒合理管控。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">消息管理:驾校通知、公告、短信提醒线上管理与发布。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">数据管理:驾校经营数据、通过率快速呈现，秒分析。</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">成绩查询:全国唯一家12123数据接口平台，考试成绩精准秒查询。</span>
                    </li>
                </ul>
                <div class="pt5 posre">
                    <div class="posre zindex1   w100p">
                        <van-image width="100%" height="100%" :src="newIcon" />
                        <!-- <img class="imgauto " src="../../public/img/img22.png" alt=""> -->
                    </div>
                    <div class="posab mauto w62p top10 bannervant zindex2">
                        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                            <van-swipe-item>
                                <img class="imgauto " src="../../public/img/1.png" alt="">
                            </van-swipe-item>
                            <van-swipe-item>
                                <img class="imgauto " src="../../public/img/1.png" alt="">
                            </van-swipe-item>
                       
                        </van-swipe>
                    </div>
                    
                </div>
            </div>
      
            <div class="mt24" v-if="isAct==2">
                <ul class="w100p disinblock">
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">集团管理：集团总部管理，分校可独立经营管</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">工 作 流 ：个性化定制工作流管理</span>
                    </li>
                    <li class="pb12 alit">
                        <i><img class="w12 h12" src="../../public/img/img21.png" alt=""></i>
                        <span class="disinblock pl4 c666 fs13">财务管理：财务统计，快速核算经营成本与利</span>
                    </li>
                    
                </ul>
                <div class="pt5 posre">
                    <div class="posre zindex1   w100p">
                        <van-image width="100%" height="100%" :src="newIcon" />
                        <!-- <img class="imgauto " src="../../public/img/img22.png" alt=""> -->
                    </div>
                    <div class="posab mauto w62p top10 bannervant zindex2">
                        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                            <van-swipe-item>
                                <img class="imgauto " src="../../public/img/1.png" alt="">
                            </van-swipe-item>
                            <van-swipe-item>
                                <img class="imgauto " src="../../public/img/1.png" alt="">
                            </van-swipe-item>
                
                        </van-swipe>
                    </div>
                
                </div>
            </div>
      
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isAct: 1,
                newIcon: require('../../public/img/img22.png'),

            };
        },
        methods: {
            changeBg(index) {
                this.isAct = index;

            }
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgact {
        background-color: #3F8DF7;
        color: #fff;
    }
    
    .bg22 {
        background-image: url('../../public/img/img22.png');
        background-size: 100%;
        background-repeat: no-repeat;
    }
    
    .bannervant {
        left: 50%;
        transform: translate(-50%, 0%);
    }
</style>